const NewsMain: React.FC = () => <Outlet />;
export default NewsMain;